import MobileDashboard from '../views/mobile-dashboard/mobile-dashboard';
import MobileVitalsDashboard from '../views/mobile-dashboard/mobile-vitals-dashboard';
import MobileVitalsDashboardRN from '../views/mobile-dashboard/mobile-vitals-dashboard-rn';
import WarrantyMobile from '../views/vitals/warranty-mobile';
import DeleteAccountMobile from '../views/vitals/delete-account-mobile';
import HeartbeatFull from '../views/heartbeat/heartbeat-full';
import TrainingMaterialsMobile from '../views/training/training-materials-mobile';
import DownloadsMobile from '../views/support/downloads-mobile';
import MobileDocuchat from '../views/mobile-dashboard/mobile-docuchat';
import DashboardPB from '../views/dashboard/dashboard-pb';

var mobileRoutes = [
    { path: '/mobile/mobile-dashboard', name: 'MobileDashboard', icon: 'mdi mdi-account-key', component: MobileDashboard },
    { path: '/mobile/mobile-clinical-videos', name: 'TrainingMaterialsMobile', icon: 'mdi mdi-account-key', component: TrainingMaterialsMobile },
    { path: '/mobile/mobile-downloads', name: 'DownloadsMobile', icon: 'mdi mdi-account-key', component: DownloadsMobile },
    { path: '/mobile/mobile-docuchat', name: 'MobileDocuchat', icon: 'mdi mdi-account-key', component: MobileDocuchat },
    { path: '/mobile/mobile-vitals-dashboard/:id', name: 'MobileVitalsDashboard', icon: 'mdi mdi-account-key', component: MobileVitalsDashboard },
    { path: '/mobile/mobile-vitals-dashboard-rn/:id', name: 'MobileVitalsDashboardRN', icon: 'mdi mdi-account-key', component: MobileVitalsDashboardRN },
    { path: '/mobile/warranty/:id', name: 'WarrantyMobile', icon: 'mdi mdi-account-key', component: WarrantyMobile },
    { path: '/mobile/delete-account', name: 'DeleteAccountMobile', icon: 'mdi mdi-account-key', component: DeleteAccountMobile },
    { path: '/heartbeat/full', name: 'HeartbeatFull', icon: 'mdi mdi-account-key', component: HeartbeatFull },
    { path: '/dashboard-pb', name: 'Dashboard PB', icon: 'mdi mdi-account-key', component: DashboardPB },
];

export default mobileRoutes;
